import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("hub_token");
export const setToken = (t) => localStorage.setItem("hub_token", t);
export const clearToken = () => localStorage.removeItem("hub_token");

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      clearToken();
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (path) => `${API}/files/${path}?auth=${getToken()}`;

export default api;
